import React from 'react';
import { Loader, BaasicTable, BaasicHeader, TableFilter } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';

const ChannelListTemplate = ({ viewStore, viewStore: { listStore, tableData, queryUtility, loading, columnFilterSetup } }) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.CHANNELS"></BaasicHeader>
			<BaasicTable {...{
				listStore,
				tableData,
				queryUtility,
				viewStore,
			}} data={listStore.data.slice()} actions={viewStore} />
			<ReactTooltip />
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
		</section>
	);
};

export default defaultTemplate(ChannelListTemplate);
